import { Dispatch, KeyboardEvent, SetStateAction, useState } from 'react';

interface UseMessageHistoryOptions {
  newMessage: string;
  setNewMessage: Dispatch<SetStateAction<string>>;
}

interface UseMessageHistoryResult {
  messageHistory: string[];
  setMessageHistory: Dispatch<SetStateAction<string[]>>;
  historyIndex: number;
  setHistoryIndex: Dispatch<SetStateAction<number>>;
  savedMessage: string;
  setSavedMessage: Dispatch<SetStateAction<string>>;
  handleHistoryNavigation: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
}

export function useMessageHistory({
  newMessage,
  setNewMessage,
}: UseMessageHistoryOptions): UseMessageHistoryResult {
  const [messageHistory, setMessageHistory] = useState<string[]>([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [savedMessage, setSavedMessage] = useState('');

  const handleHistoryNavigation = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'ArrowUp') {
      const textarea = e.currentTarget;
      const textBeforeCursor = textarea.value.substring(
        0,
        textarea.selectionStart
      );
      const isOnFirstLine = !textBeforeCursor.includes('\n');
      if (isOnFirstLine && messageHistory.length > 0) {
        e.preventDefault();
        if (historyIndex === -1) {
          setSavedMessage(newMessage);
        }
        const newIndex =
          historyIndex === -1
            ? messageHistory.length - 1
            : Math.max(0, historyIndex - 1);
        setHistoryIndex(newIndex);
        setNewMessage(messageHistory[newIndex]);
      }
    } else if (e.key === 'ArrowDown') {
      if (historyIndex >= 0) {
        const textarea = e.currentTarget;
        const textAfterCursor = textarea.value.substring(
          textarea.selectionStart
        );
        const isOnLastLine = !textAfterCursor.includes('\n');
        if (isOnLastLine) {
          e.preventDefault();
          const newIndex = historyIndex + 1;
          if (newIndex >= messageHistory.length) {
            setHistoryIndex(-1);
            setNewMessage(savedMessage);
            setSavedMessage('');
          } else {
            setHistoryIndex(newIndex);
            setNewMessage(messageHistory[newIndex]);
          }
        }
      }
    }
  };

  return {
    messageHistory,
    setMessageHistory,
    historyIndex,
    setHistoryIndex,
    savedMessage,
    setSavedMessage,
    handleHistoryNavigation,
  };
}
